import { useState } from 'react'
import { Link } from 'react-router-dom'
import { requestPasswordReset } from '../../api/auth'
import AuthPage, { AuthField } from '../../components/PublicLayout'
import { parseCompanyId, rememberedCompanyId } from '../../utils/companyId'

export default function ForgotPassword() {
  const [companyId, setCompanyId] = useState(rememberedCompanyId)
  const [email, setEmail] = useState('')
  const [busy, setBusy] = useState(false)
  const [err, setErr] = useState('')
  const [done, setDone] = useState(false)

  const submit = async (e) => {
    e && e.preventDefault()
    const company = parseCompanyId(companyId)
    if (company.error) { setErr(company.error); return }
    if (!email) { setErr('Enter your email address.'); return }
    setBusy(true); setErr('')
    try {
      await requestPasswordReset(email, company.id)
      setDone(true)
    } catch (e) {
      setErr(String(e?.response?.data?.message || e?.response?.data?.error || e?.message || e))
      setDone(false)
    } finally { setBusy(false) }
  }

  return (
    <AuthPage
      title="Forgot your password?"
      intro="We’ll email you a link to choose a new one."
      top={<Link className="pub-btn pub-btn-ghost" to="/login">Sign in</Link>}
      foot={<>Remembered it? <Link to="/login">Sign in</Link></>}
    >
      <form onSubmit={submit} className="pub-form" noValidate>
        <AuthField id="forgot-company" label="Company ID" hint="The number your welcome email calls Tenant ID.">
          <input id="forgot-company" value={companyId} onChange={(e) => setCompanyId(e.target.value)} inputMode="numeric" autoComplete="organization" autoFocus={!companyId} />
        </AuthField>
        <AuthField id="forgot-email" label="Email">
          <input id="forgot-email" type="email" value={email} onChange={(e) => { setEmail(e.target.value); setDone(false) }} autoComplete="email" autoFocus={!!companyId} />
        </AuthField>
        {err && <p className="pub-error" role="alert">{err}</p>}
        {done && !err && <p className="pub-notice pub-notice-good" role="status">If there’s an account with that email, a link to reset the password is on its way. Check your inbox and spam folder.</p>}
        <button type="submit" className="pub-btn pub-btn-primary pub-btn-block" disabled={busy}>{busy ? 'Sending…' : 'Send the reset link'}</button>
      </form>
    </AuthPage>
  )
}
